module.exports = __webpack_public_path__ + "img/bs.3dbb14bf.png";